import * as React from 'react';
import { XEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var TwitterOrX = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(XEmbed, { url: link, width: "100%" })));
};
